import { useState } from "react";
import { Image, InputGroup, InputRightElement } from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";

// Ô chọn khoảng ngày giống các trang khác của web (vd Quản lý đăng kí chấm công ngoài)
export default function FuelDateRange({ value, onChange, placeholder }) {
  const [startDate, endDate] = value;
  const [zIndex, setZIndex] = useState(1);

  return (
    <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
      <DatePicker
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        dateFormat="dd/MM/yyyy"
        locale="vi"
        onChange={(update) => onChange(update)}
        onFocus={() => setZIndex(3)}
        onBlur={() => setZIndex(1)}
        isClearable={true}
        placeholderText={placeholder}
        className="datePickerStyle"
      />
      {!startDate && !endDate && (
        <InputRightElement pointerEvents="none" h={"44px"}>
          <Image src={calendarIcon} />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
